import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "../../../../hooks/useForm";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import { Button, Grid, IconButton, List, ListItem, Typography } from "@material-ui/core";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { useDispatch, useSelector } from "react-redux";
import { ModalAgregarMail } from "./ModalAgregarMail";
import DeleteIcon from "@material-ui/icons/Delete";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";
import { BajaMailOferente, FetchEmailsOferentes, desSeleccionarMailOferente } from "../../../../actions/compras/OferentesAction";

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
})

export const FormOferentesFormulario = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { oferente, permisoEdit, permisoAlta, oferentes,esCarga } = props;
    const { permisos: permisosUser } = useSelector(state => state.auth)
    const [abrirModalMail, setAbrirModalMail] = useState(false);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [openIngresarCuitDuplicado, setOpenQuestionCuitDuplicado] = useState(false);

    const formInicial = {
        cuit: "",
        razonSocial: "",
        mail: ""
    }
    const [formValues, handleInputChange] = useForm(oferente ? oferente : formInicial)
    const { mailsOferentes } = useSelector((state) => state.compras);

    const onSubmit = (e) => {
        e.preventDefault()
        debugger
        var cuitExistente = oferentes?.filter(x => x.cuit === formValues.cuit && x.fechaBaja === null);
        if (cuitExistente && cuitExistente.length > 0 && esCarga) {
            setOpenQuestionCuitDuplicado(true);
        } else {
            props.handleSave(formValues)
        }
    }
        const handleEliminarEmail = (idOferenteMail) => {
            dispatch(BajaMailOferente(oferente.idOferente, idOferenteMail));
            setOpenQuestion(false);
        }
        useEffect(() => {
            if (oferente?.idOferente) {
                dispatch(FetchEmailsOferentes(oferente?.idOferente));
            } else {
                dispatch(desSeleccionarMailOferente());
            }
        }, [oferente])
        return (
            <>
                {
                    abrirModalMail &&
                    <ModalAgregarMail
                        open={abrirModalMail}
                        close={() => setAbrirModalMail(false)}
                        idOferente={oferente.idOferente}
                    />
                }
                {
                    openIngresarCuitDuplicado && (
                        <AlertFinalizadoStepper
                            open={openIngresarCuitDuplicado}
                            pregunta={"Cargar Cuit"}
                            dialogText={`El cuit que intenta ingresar ya se encuentra cargado. Desea cargarlo nuevamente?`}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Confirmar"}
                            handleClose={() => setOpenQuestionCuitDuplicado(false)}
                            handleSend={() => {props.handleSave(formValues)
                                setOpenQuestionCuitDuplicado(false)}
                            }
                        />
                    )
                }
                <ValidatorForm onSubmit={onSubmit}>
                    <Grid container style={{ padding: 25 }}>
                        <Grid item xs={12} md={6}>
                            <TextValidator
                                margin="normal"
                                label="Cuit"
                                name="cuit"
                                value={formValues.cuit}
                                autoComplete="off"
                                onChange={handleInputChange}
                                fullWidth
                                style={{ paddingRight: "0.5rem" }}
                                validators={[
                                    "required",
                                    "isNumber",
                                    "maxNumber:99999999999",
                                    "minNumber:9999999999",
                                ]}
                                errorMessages={[
                                    "Este campo es obligatorio",
                                    "Solo numeros",
                                    "Verifique el Cuil ingresado",
                                    "Verifique el Cuil ingresado",
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextValidator
                                margin="normal"
                                label="Razon Social"
                                name="razonSocial"
                                value={formValues.razonSocial}
                                autoComplete="off"
                                onChange={handleInputChange}
                                fullWidth
                                style={{ paddingRight: "0.5rem" }}
                                validators={["required"]}
                                errorMessages={["La razón social es requerida"]}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextValidator
                                margin="normal"
                                label="Email"
                                name="mail"
                                value={formValues.mail}
                                autoComplete="off"
                                onChange={handleInputChange}
                                fullWidth
                                style={{ paddingRight: "0.5rem" }}
                                validators={["required", "isEmail"]}
                                errorMessages={["El email es requerido", "Email invalido"]}
                            />
                        </Grid>

                    </Grid>
                    <Grid>
                        <Typography variant="button" style={{ padding: '0.5rem' }}>Otros mails agregados:</Typography>
                        <List>
                            {
                                mailsOferentes?.map(a => {
                                    return (
                                        <>
                                            <ListItem>
                                                <Typography>{a.email} <IconButton><DeleteIcon onClick={() => setOpenQuestion(true)} /></IconButton></Typography>
                                            </ListItem>
                                            {
                                                openQuestion && (
                                                    <AlertFinalizadoStepper
                                                        open={openQuestion}
                                                        pregunta={"Eliminar email"}
                                                        dialogText={`Está seguro de eliminar el mail?`}
                                                        buttonCancel={"Cancelar"}
                                                        buttonSubmit={"Confirmar"}
                                                        handleClose={() => setOpenQuestion(false)}
                                                        handleSend={() => handleEliminarEmail(a.idEmailOferente)}
                                                    />
                                                )
                                            }
                                        </>
                                    )
                                })
                            }
                        </List>
                    </Grid>
                    <Grid>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            style={{ marginLeft: "0.7rem" }}
                            onClick={() => setAbrirModalMail(true)}
                            disabled={!oferente?.idOferente}
                        >
                            + AGREGAR MAIL
                        </Button>
                    </Grid>
                    <Grid container className={classes.botonera} >
                        <Grid item xs={12}>
                            <Grid
                                container
                                spacing={1}
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={props.cerrarModal}

                                >
                                    CANCELAR
                                </Button>
                                {(validarSoloUnPermiso(permisosUser, permisoAlta) || validarSoloUnPermiso(permisosUser, permisoEdit)) &&

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<SaveIcon />}
                                        type='submit'
                                        style={{ marginLeft: "0.5rem" }}
                                    >
                                        GUARDAR
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                </ValidatorForm>
            </>
        )
    }

    export default FormOferentesFormulario;